module.exports = __webpack_public_path__ + "img/kabao.d7e1952f.png";